/** Explicit order for filter categories - ensures consistent display regardless of backend response order */
export const FILTER_CATEGORY_ORDER = ['face', 'glue', 'back', 'service', 'certificates'] as const;

/**
 * Recursively sorts filters and their children by order property
 * @param filters - Array of filters with optional order and children properties
 * @returns Sorted array of filters with all nested children also sorted
 */
export const sortFiltersByOrder = <T extends { order?: number; children?: T[] }>(
  filters: T[],
): T[] => filters
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map(filter => ({
      ...filter,
      children: filter.children ? sortFiltersByOrder(filter.children) : filter.children,
    }));
